"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableRow = function (_a) {
    var children = _a.children, dusk = _a.dusk;
    return react_1.default.createElement("tr", { "data-dusk": dusk }, children);
};
exports.default = TableRow;
//# sourceMappingURL=TableRow.js.map